export enum IndexFormat {
    /** 8 位无符号整型索引格式。*/
    UInt8,
    /** 16 位无符号整型索引格式。*/
    UInt16,
    /** 32 位无符号整型索引格式。*/
    UInt32
}